import { memo } from 'react'
import { Redirect } from 'react-router-dom'

import PublicRoute from 'routes/components/PublicRoute'
import { useAuth, useMyProfile } from 'api'
import { appRoutes } from 'routes'
import Button from 'components/ui/Button'
import { useLegalInfo } from 'api/hooks/queries/useLegalInfo'

import ProfileRequired from './components/ProfileRequired'
import LoadingView from './components/LoadingView'
import ErrorView from './components/ErrorView'

import { ProtectedRouteProps } from '.'

const ProtectedRoute = ({ nonAuthorized, policies, ...rest }: ProtectedRouteProps) => {
  const { isReady, isLoading, logout } = useAuth()
  const myProfile = useMyProfile()
  const legalInfo = useLegalInfo()

  if (myProfile.isLoading || isLoading || legalInfo.isLoading) {
    return (
      <div style={{ alignSelf: 'center', width: '100%', textAlign: 'center' }}>
        <LoadingView />
      </div>
    )
  }

  if (isReady && myProfile.error?.type === '0003') {
    return (
      <ErrorView
        title='User is banned. Please contact support'
        text={
          <Button size={'small'} onClick={logout}>
            Log out
          </Button>
        }
      />
    )
  }

  if (isReady && (myProfile.error != null || myProfile.data == null)) {
    return <ErrorView title='Profile loading failed. Please, try reloading the page' />
  }

  if (legalInfo.error != null || legalInfo.data == null) {
    return <ErrorView title='Info loading failed. Please, try reloading the page' />
  }

  if (nonAuthorized && isReady) {
    return <Redirect to={appRoutes.main.path} />
  }

  const { authorized, verified, ...routeProps } = rest

  if (authorized || verified) {
    return <ProfileRequired {...rest} />
  }

  return <PublicRoute {...routeProps} />
}

export default memo(ProtectedRoute)
